<template>
  <no-ssr>
    <lazy-component class="map-activities" @show="loadScripts">
      <div
        :id="id"
        ref="container"
        class="map-activities__container u-absolute-full mapboxgl-map"
        :class="{ _preloader: preloader }"
      ></div>
    </lazy-component>
  </no-ssr>
</template>

<script>
import $script from "scriptjs";
import mapboxgl from "mapbox-gl";
import { getUniqueId } from "@/assets/js/utils/get-unique-id";
import noSSR from "vue-no-ssr";

export default {
  components: {
    "no-ssr": noSSR,
  },
  props: {
    coordinates: {
      type: [String, Object],
      required: true,
    },
  },
  data() {
    return {
      markers: [],
      preloader: true,
    };
  },
  computed: {
    id() {
      return getUniqueId("map-activities-");
    },
  },
  methods: {
    loadScripts() {
      $script(["/static/vendor/turf.min.js"], "mapbox-bundle");
      $script.ready("mapbox-bundle", () =>
        this.createMapBox(this.removePreloader)
      );
    },
    createMapBox(removePreloaderCallBack) {
      const { id, coordinates: object, markers, getBounds } = this;

      mapboxgl.accessToken = fakeWindow.mapBoxKey;
       // "pk.eyJ1IjoieXRtZSIsImEiOiJjbGdjNDlvODgwMGtkM2tsNnU5aGlyOXp6In0.uzf2uJq71nTLPf-jvXqrsQ";

      const map = new mapboxgl.Map({
        container: id,
        style: "mapbox://styles/ytme-app/cljzo3n2k009301pkffhrgkgr",
        center: object.center,
        zoom: object.zoom,
      });

      const geojson = {
        type: "FeatureCollection",
        features: [],
      };

      // путь для анимации
      const route = {
        type: "FeatureCollection",
        features: [],
      };
      // динамичная точка для анимации
      const tourist = {
        type: "FeatureCollection",
        properties: [],
        features: [],
      };

      if (object.route) {
        const routeLines = object.route;
        routeLines.push(object.route[0]);

        geojson.features.push({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: routeLines,
          },
        });

        route.features.push({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: routeLines,
          },
        });

        tourist.features.push({
          type: "Feature",
          properties: {},
          geometry: {
            type: "Point",
            coordinates: object.route[0],
          },
        });

        object.route.forEach(function (coordinate, i) {
          if (object.day_number[i] === undefined) return true;
          geojson.features.push({
            type: "Feature",
            properties: {
              description: object.day_description[i],
              day: object.day_number[i],
            },
            geometry: {
              type: "Point",
              coordinates: coordinate,
            },
          });
        });
      }

      let markersCoord = [];
      geojson.features.forEach(function (item, index) {
        if (item.geometry.type === "Point") {
          if (item.properties.day === undefined) return true;
          markers.push(item.geometry.coordinates);
          const el = document.createElement("div");
          if (
            markersCoord[item.geometry.coordinates] &&
            markersCoord[item.geometry.coordinates] !== undefined
          ) {
            el.append(
              markersCoord[item.geometry.coordinates]._element.innerHTML
            );
            el.append(",");
            el.append(item.properties.day);
            el.className = "map-activities__marker--big";
            markersCoord[item.geometry.coordinates].remove();
          } else {
            el.append(item.properties.day);
          }
          el.className = el.classList + " map-activities__marker";
          if (index === 0) {
            el.className =
              el.classList +
              "map-activities__marker  map-activities__marker--first";
          }
          markersCoord[item.geometry.coordinates] = new mapboxgl.Marker(el)
            .setLngLat(item.geometry.coordinates)
            .addTo(map);
        }
      });

      // вся дистанция для анимации
      const lineDistance = fakeWindow.turf.length(route.features[0]);
      const arc = [];
      // шаги для анимации
      const steps = 500;
      for (let i = 0; i < lineDistance; i += lineDistance / steps) {
        const segment = fakeWindow.turf.along(route.features[0], i);
        arc.push(segment.geometry.coordinates);
      }
      route.features[0].geometry.coordinates = arc;
      let counter = 0;

      map.on("load", function () {
        map.addSource("route", {
          type: "geojson",
          data: geojson,
        });

        map.addSource("places", {
          type: "geojson",
          data: geojson,
        });

        map.addSource("tourist", {
          type: "geojson",
          data: tourist,
        });

        map.addLayer({
          id: "places",
          type: "circle",
          source: "places",
          paint: {
            "circle-color": "#EF7F1A",
            "circle-radius": 6,
            "circle-stroke-width": 0,
          },
        });

        map.addLayer({
          id: "route",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#EF7F1A",
            "line-width": 2,
          },
          filter: ["in", "$type", "LineString"],
        });

        map.loadImage(
          "/local/templates/youtravel/static/i/tour-page/arrow.png",
          (error, image) => {
            map.addImage("arrow", image);
          }
        );

        map.addLayer({
          id: "tourist",
          source: "tourist",
          type: "symbol",
          layout: {
            "icon-image": "arrow", // reference the image
            "icon-size": 1,
            "icon-rotate": ["get", "bearing"],
            "icon-rotation-alignment": "map",
            "icon-allow-overlap": true,
            "icon-ignore-placement": true,
          },
        });

        let requestFrame;

        function animate() {
          const start =
            route.features[0].geometry.coordinates[
              counter >= steps ? counter - 1 : counter
            ];
          const end =
            route.features[0].geometry.coordinates[
              counter >= steps ? counter : counter + 1
            ];

          if (!start || !end) return;
          tourist.features[0].geometry.coordinates =
            route.features[0].geometry.coordinates[counter];

          tourist.features[0].properties.bearing = fakeWindow.turf.bearing(
            fakeWindow.turf.point(start),
            fakeWindow.turf.point(end)
          );

          map.getSource("tourist").setData(tourist);

          if (counter < steps - 10) {
            requestFrame = requestAnimationFrame(animate);
          } else {
            cancelAnimationFrame(requestFrame);
            counter = 0;
            animate(counter);
          }

          counter = counter + 1;
        }
        animate(counter);
        if (markers.length > 1) {
          let bounds = getBounds(markers);
          map.fitBounds(bounds);
        }

        const popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
        });

        map.on("mousemove", "places", (e) => {
          if (e.features[0].properties.description === undefined) return;
          map.getCanvas().style.cursor = "pointer";
          const coordinates = e.features[0].geometry.coordinates.slice();
          const description = e.features[0].properties.description;
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          popup.setLngLat(e.lngLat).setHTML(description).addTo(map);
        });

        map.on("mouseleave", "places", () => {
          map.getCanvas().style.cursor = "";
          popup.remove();
        });
      });

      removePreloaderCallBack();
    },
    removePreloader() {
      this.preloader = false;
    },
    getBounds(markers) {
      let Lng = [];
      let Lat = [];
      let coef = 0.2;

      markers.forEach((LngLat) => {
        Lng.push(LngLat[0]);
        Lat.push(LngLat[1]);
      });

      return [
        [Math.min.apply(Math, Lng) - coef, Math.min.apply(Math, Lat) - coef],
        [Math.max.apply(Math, Lng) + coef, Math.max.apply(Math, Lat) + coef],
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css";

@keyframes map-activities-preloader-background {
  50% {
    background: var.$white;
  }
}

$b: ".map-activities";

#{$b} {
  @include mixin.aspect-ratio(343, 170);
  position: relative;
  border-radius: 16px;
  overflow: hidden;

  &__container {
    &::after {
      @include mixin.full-pos(0);
      content: "";
      display: block;
      position: absolute;
      z-index: 2;
      background: var.$gray-dark;
      animation: map-activities-preloader-background 3s infinite alternate;
    }

    &:not(._preloader) {
      &::after {
        opacity: 0;
        visibility: hidden;
      }
    }
  }

  >>> {
    #{$b} {
      &__marker {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ef7f1aff;
        border-radius: 50%;
        height: 20px;
        width: 20px;
        color: var.$white;
        cursor: pointer;

        &--first {
          background-color: #662170ff;
        }

        &--big {
          height: 30px;
          width: 30px;
        }
      }
    }

    .mapboxgl-ctrl.mapboxgl-ctrl-attrib {
      margin: 10px;
    }

    .mapboxgl-ctrl-attrib-button {
      display: block;
      top: auto;
      bottom: 0;
    }

    .mapboxgl-ctrl-attrib-inner {
      display: none;
    }

    .mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-inner {
      display: block;
    }
  }
}
</style>
